import { Suspense } from "react";
import {
  SearchFiltersContextProvider,
  SearchUsersList,
} from "~/components/common/searchUsersList";
import { Box } from "~/components/ui/box";
import { Spinner } from "~/components/ui/spinner";

export const UsersPage = () => (
  <Suspense
    fallback={
      <Box
        display="flex"
        justify="center"
        align="center"
        sx={{ height: "100%" }}
      >
        <Spinner />
      </Box>
    }
  >
    <SearchFiltersContextProvider>
      <SearchUsersList />
    </SearchFiltersContextProvider>
  </Suspense>
);
